// @flow
import React from "react"
import type { AffiliateFull } from "data/affiliate/types"
import RegularOpeningHoursTable from "./OpeningHoursTable/Regular"
import SpecialOpeningHoursTable from "./OpeningHoursTable/Special"
import { AffiliateLink, LinkWrap, SectionTitle } from "../styled"

type Props = {|
  affiliate: AffiliateFull,
|}

const Info = ({ affiliate }: Props) => (
  <React.Fragment>
    <SectionTitle>Address</SectionTitle>
    <LinkWrap>
      <AffiliateLink
        to={`https://www.google.com/maps/search/${affiliate.address
          .split(" ")
          .join("+")}`}
      >
        {affiliate.address}
      </AffiliateLink>
    </LinkWrap>

    <SectionTitle>Store hours</SectionTitle>
    <RegularOpeningHoursTable data={affiliate.openingHours} />
    <SpecialOpeningHoursTable data={affiliate.specialOpeningDates} />
  </React.Fragment>
)

export default Info



// WEBPACK FOOTER //
// ./src/pages/Affiliate/Content/Info/index.js